/**
 * A custom element that wraps a quantity input
 */
if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      this.plusButton = this.querySelector('button[name="plus"]');
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInputChange = this.onInputChange.bind(this);

      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick));
      this.input?.addEventListener('change', this.onInputChange);

      this.updatePlusButtonState();
    }

    disconnectedCallback() {
      this.querySelectorAll('button').forEach(button => button.removeEventListener('click', this.onButtonClick));
      this.input?.removeEventListener('change', this.onInputChange);
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

      this.updatePlusButtonState();

      if (previousValue !== this.input.value) {
        this.dispatchQuantityChange();
      }
    }

    // Fires on blur or Enter after typing in the input directly
    onInputChange() {
      const min = parseInt(this.input.min) || 0;
      const max = parseInt(this.input.max);
      let value = parseInt(this.input.value);

      // An empty or invalid value falls back to the rendered (server) quantity
      if (isNaN(value)) value = parseInt(this.input.defaultValue) || min;
      value = Math.max(min, value);
      if (!isNaN(max)) value = Math.min(max, value);

      this.input.value = value;

      this.updatePlusButtonState();
      this.dispatchQuantityChange();
    }

    updatePlusButtonState() {
      const max = parseInt(this.input?.max);
      if (!this.plusButton || isNaN(max)) return;

      this.plusButton.toggleAttribute('disabled', parseInt(this.input.value) >= max);
    }

    dispatchQuantityChange() {
      this.dispatchEvent(
        new CustomEvent('quantity-change', {
          bubbles: true,
          detail: {
            quantity: this.input.value,
            id: this.input.dataset.productId,
            key: this.input.dataset.key || null,
          },
        }),
      );
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
